import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineChartComponent } from './components/line-chart.component';
import { CombinationChartComponent } from './components/combination-chart.component';
import { NavigatorChartComponent } from './components/navigator-chart.component';

@NgModule({
  declarations: [
    LineChartComponent,
    CombinationChartComponent,
    NavigatorChartComponent,
  ],
  imports: [CommonModule],
  exports: [
    LineChartComponent,
    CombinationChartComponent,
    NavigatorChartComponent,
  ],
})
export class SharedChartsModule {}
